import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useParams } from 'react-router'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { Table } from '../../../common/table/index'
import { formatVal } from '../../../helpers/value'
import classes from '../index.module.scss'
import {
  selectAlertById,
  selectAlertIds,
  selectCompanyInfo,
} from '../store/slice'
import { TABLE_COL } from './constant'
import { TableCell } from './TableCell'

export const Alerts = ({ data, isCompany, isMacro }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const { alertId } = useParams()
  const { organizationName } = useSelector(selectCompanyInfo)
  const ids = useSelector(selectAlertIds)

  const macroText = UseI18n('alertDetail.MACROECONOMIC')
  const panelLabel =
    UseI18n('alertDetail.ALERT_FOR') +
    (isCompany
      ? organizationName
      : isMacro
      ? macroText
      : data?.industry?.industryName)

  const getSchema = () => {
    const colums = isCompany
      ? Object.keys(TABLE_COL)
      : Object.keys(TABLE_COL).slice(0, -1)

    return colums.map((key) => {
      const title = `alertDetail.${key}`
      const colId = TABLE_COL[key]
      const tdStyle = {
        width: [TABLE_COL.STT].includes(colId) ? 40 : '',
      }

      return {
        colId,
        title,
        isI18n: true,
        tdStyle,
        render: (data, { rowId, rowIndex }) => (
          <TableCell
            data={data}
            colId={colId}
            rowId={rowId}
            rowIndex={rowIndex}
          />
        ),
      }
    })
  }

  return (
    <Panel label={panelLabel} isI18n={false}>
      <Element
        className={classes.note}
        style={{ color: '#3A414B', borderBottomColor: '#B5CEF8' }}
      >
        {isCompany && <Translate value="alertDetail.ALERT_FOR_COMPANY_NOTE" />}
        <Element>
          <Translate value="alertDetail.TOTAL_ALERTS" />
          :&nbsp;
          {formatVal(ids.length, locale, false, 0)}
        </Element>
      </Element>

      <Table
        ids={ids}
        getDataFromRedux={selectAlertById}
        selectedRowId={Number(alertId)}
        schema={getSchema()}
        isNoDataWithHead
        isCenterNoData={false}
        noDataText="alerts.NO_ALERT_TO_DISPLAY"
        autoHeightMax={600}
      />
    </Panel>
  )
}
